import ko from "./locales/ko.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import cn from "./locales/cn.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import id from "./locales/id.json";
import jp from "./locales/jp.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import th from "./locales/th.json";
import tr from "./locales/tr.json";
import tw from "./locales/tw.json";
import vn from "./locales/vn.json";

const resources = {
  ko: {
    translation: ko,
  },
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
  cn: {
    translation: cn,
  },
  de: {
    translation: de,
  },
  es: {
    translation: es,
  },
  fr: {
    translation: fr,
  },
  id: {
    translation: id,
  },
  jp: {
    translation: jp,
  },
  pt: {
    translation: pt,
  },
  ru: {
    translation: ru,
  },
  th: {
    translation: th,
  },
  tr: {
    translation: tr,
  },
  tw: {
    translation: tw,
  },
  vn: {
    translation: vn,
  },
};

export default resources;
